import { AggregateRoot, UniqueEntityId } from "@kernel/ddd";
import { cloneDeep } from "lodash";

export type MediaDeviceOption = { value: string; label: string };

export interface DeviceProps {
  info: MediaDeviceInfo;
}

export class Device extends AggregateRoot<DeviceProps> {
  public clone(): Device {
    const props = cloneDeep(this.props);
    return Device.create(props, this._id);
  }

  public toString(): string {
    throw new Error("Method not implemented.");
  }

  public get info(): MediaDeviceInfo {
    return this.props.info;
  }

  public get id(): UniqueEntityId {
    return this._id;
  }

  public get label(): string {
    return this.info.label;
  }

  public get kind(): MediaDeviceKind {
    return this.info.kind;
  }

  public get groupId(): string {
    return this.info.groupId;
  }

  public isAudioInput(): boolean {
    return this.kind === "audioinput";
  }

  public isAudioOutput(): boolean {
    return this.kind === "audiooutput";
  }

  public isVideoInput(): boolean {
    return this.kind === "videoinput";
  }

  public isKind(kind: MediaDeviceKind): boolean {
    return this.kind === kind;
  }

  public toJSON(): any {
    return this.info.toJSON();
  }

  public toOption(): MediaDeviceOption {
    return {
      value: this.id.toString(),
      label: this.label
    };
  }

  public static create(props: DeviceProps, id: UniqueEntityId): Device {
    return new Device(props, id);
  }
}
